import { z } from 'zod';

import { observabilityAppService } from '@ctct/myaccount-utils-static';

class ZodService {
  private readonly NOTIFY_ERRORS = false;

  public safeParse<T>(schema: z.ZodType<T, z.ZodTypeDef, unknown>, data: unknown): T {
    const parsed = schema.safeParse(data);

    if (parsed.success) {
      return parsed.data;
    }

    if (this.NOTIFY_ERRORS) {
      // If parsing fails, log the error using observability service
      observabilityAppService.notify(new Error(parsed.error.message), {
        error: parsed.error,
      });
    }

    return data as T;
  }

  public safeParseString(data: unknown): string {
    return this.safeParse(z.string(), data);
  }

  public safeParseNumber(data: unknown): number {
    return this.safeParse(z.number(), data);
  }

  public safeParseBool(data: unknown): boolean {
    return this.safeParse(z.boolean(), data);
  }
}

export const zodService = new ZodService();
